import { render } from "./JournalArticle.vue?vue&type=template&id=a9b2132c"
import script from "./JournalArticle.vue?vue&type=script&lang=js"
export * from "./JournalArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__